/**
 * Ícone SVG de código de barras representando Boleto bancário
 * 
 * Barras verticais estilizadas simulando código de barras
 */

import { cn } from '@/lib/utils';

interface BoletoIconProps {
  className?: string;
}

export function BoletoIcon({ className }: BoletoIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-6 w-6', className)}
    >
      {/* Barras de código de barras */}
      <rect x="2" y="4" width="2" height="16" fill="currentColor" />
      <rect x="5" y="4" width="1" height="16" fill="currentColor" />
      <rect x="7" y="4" width="2" height="16" fill="currentColor" />
      <rect x="10" y="4" width="1" height="16" fill="currentColor" />
      <rect x="12" y="4" width="3" height="16" fill="currentColor" />
      <rect x="16" y="4" width="1" height="16" fill="currentColor" />
      <rect x="18" y="4" width="2" height="16" fill="currentColor" />
      <rect x="21" y="4" width="1" height="16" fill="currentColor" />
    </svg>
  );
}
